import React from 'react';
import ToolTip from 'src/components/Shared/ToolTip/ToolTip';
import config from 'src/config/config';
import { PopUpPosition } from 'src/types';

export interface CostBasisToolTipProps {
  styles: Record<string, string>;
  id?: string;
}
const CostBasisToolTip: React.FC<CostBasisToolTipProps> = ({ styles }) => (
  <ToolTip
    callerText="Cost Basis Method:"
    message={
      <div>
        <p className={styles['paragraph']}>
          Cost basis is used to determine what your capital gains/losses may be,
          based on which shares are sold.
        </p>
        <p className={styles['paragraph']}>
          Fluctuations in the market mean shares you own may have different
          purchase prices within one fund.
        </p>
        <p>
          <a
            href={`${config.url}/personal-investing/resources/planning/tax/education/cost-basis-accounting-and-calculation.html`}
            rel="noreferrer"
            target="_blank"
          >
            Learn more about cost basis methods
          </a>
        </p>
      </div>
    }
    popOutPlacement={PopUpPosition.TOP}
  />
);

export default CostBasisToolTip;
